import { InMemoryCache } from '@apollo/client';
import { RecentActivityPagedResult } from 'domains/dashboard/components/recent-activity/RecentActivity.component';
import { uniqBy } from 'lodash-es';

export const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        recentActivities: {
          keyArgs: false,
          merge(existing: RecentActivityPagedResult | undefined, incoming: RecentActivityPagedResult) {
            return {
              afterCursor: incoming.afterCursor,
              data: uniqBy([...(existing?.data || []), ...incoming.data], '__ref'),
            };
          },
        },
      },
    },
  },
});
